import styled from "styled-components";

export const DivTech = styled.ul`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    width: 100%;
    padding: 10px;
    gap: 20px;
    background-color: #212529;
    border-radius: 4px;


    li{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 95%;
        background-color: #121214;
        padding: 0 10px;
        border-radius: 4px;
        div{
            display: flex;
            flex-direction: row;
            gap: 20px;
        }

    }
`;